import { h } from '@stencil/core';
import { QdsImportance, QdsSize } from '@pes-ui/utils';
const TITLE_MAX_HEIGHT = '40px';
const DESCRIPTION_MAX_HEIGHT = '80px';
export class PesItemCard {
  constructor() {
    this.image = undefined;
    this.title = undefined;
    this.description = undefined;
    this.linkUrl = undefined;
    this.linkText = undefined;
    this.commercialReference = undefined;
  }
  render() {
    const { image, title, description, linkUrl, linkText, commercialReference } = this;
    return (h("a", { href: linkUrl, class: "pes-item-card" }, h("div", { class: "pes-item-card__main" }, h("img", { src: image === null || image === void 0 ? void 0 : image.url, alt: image === null || image === void 0 ? void 0 : image.title, class: "pes-item-card__image" }), h("div", { class: "pes-item-card__content" }, h("p", { class: "pes-item-card__content-reference" }, commercialReference), title
      && h("pes-ellipsis", { class: "pes-item-card__content-title", maxHeight: TITLE_MAX_HEIGHT, wrapperModifier: "left", modifier: "card", content: title }), description
      && h("pes-ellipsis", { class: "pes-item-card__content-description", maxHeight: DESCRIPTION_MAX_HEIGHT, wrapperModifier: "left", modifier: "card", content: description }))), linkText && linkUrl && (h("div", { class: "pes-item-card__link" }, h("qds-standalone-link", { iconName: "chevron-icon-crop", importance: QdsImportance.EMPHASIZED, size: QdsSize.STANDARD, href: linkUrl }, linkText)))));
  }
  static get is() { return "pes-item-card"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-item-card.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-item-card.css"]
    };
  }
  static get properties() {
    return {
      "image": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "OfferImage",
          "resolved": "OfferImage",
          "references": {
            "OfferImage": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "description",
        "reflect": false
      },
      "linkUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "link-url",
        "reflect": false
      },
      "linkText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "link-text",
        "reflect": false
      },
      "commercialReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "commercial-reference",
        "reflect": false
      }
    };
  }
}
